export default __webpack_public_path__ + "static/media/g1.08179f47.jpg";